class RoomComparison {
  constructor(el) {
    if (!el) return
    this._bind();

    this.dom = {
      el,
      roomContainer: el.querySelector(".room-container"),
      middle: el.querySelector(".room-container .middle"),
      patterns: el.querySelectorAll(".room-container .middle .image-pattern"),
      bottom: el.querySelectorAll(".room-container .bottom")[0],
      top: el.querySelectorAll(".room-container .top")[0],
      adjustmentLayer: el.querySelectorAll(".room-container .adjustment-layer")[0],
      slideEl: el.querySelector(".room-slider"),
      slideElCircle: el.querySelector(".room-slider .circle"),
      slideElCircleOuter: el.querySelector(".room-slider .circle .outer"),

      buttons: el.querySelectorAll(".room-selection")
    }

    this.data = {
      ease: 0.15,
      isMouseDown: false,
      isVisible: true,
    }

    const windowWidth = getViewport().width;

    if (windowWidth < 768) this.getBounds()

    if (!isMobile) {
      this.speed = new MouseSpeed()
      this.speed.init(this.setSpeed);
      this.speedX = 0;
      this.speedY = 0;
    }

    this.clip = {
      isTweening: false,
      top: 50,
      bottom: 50,
      mulitiplier: -.7,
    }

    this._addEvents();
  }

  _bind() {
    ['move', 'getBounds', 'mouseLeave', 'setSpeed', 'circleDown', 'circleUp', 'switchRoom', 'resize', 'setPatternSize']
      .forEach(fn => this[fn] = this[fn].bind(this));
  }

  _addEvents() {

    if (!this.dom || !this.dom.roomContainer) return;

    let _this = this;
    this.dom.roomContainer.addEventListener("mouseenter", this.getBounds, false);
    this.dom.roomContainer.addEventListener("mousemove", this.move, false);
    this.dom.roomContainer.addEventListener("mouseleave", this.mouseLeave, false);

    this.dom.slideElCircle.addEventListener("mousedown", this.circleDown, false);
    this.dom.roomContainer.addEventListener("mouseup", this.circleUp, false);

    this.dom.roomContainer.addEventListener("touchmove", this.move, false);
    this.dom.slideElCircle.addEventListener("touchstart", this.circleDown, false);
    this.dom.slideElCircle.addEventListener("touchend", this.circleUp, false);

    Array.prototype.slice.call(this.dom.buttons).forEach(button => {
      let room = button.dataset.room;
      let scaleFactor = button.dataset.scaleFactor;

      button.addEventListener("click", function () { _this.switchRoom(button, room, scaleFactor) }, false);
    })

    // Set the Size of the pattern
    this.setPatternSize(this.dom.buttons[0].dataset.scaleFactor)
  }

  /*--------  UI --------*/
  switchRoom(el, newRoom, scaleFactor) {
    let layers = this.dom.el.querySelectorAll(`.room-container [data-room='${newRoom}']`)

    if (!layers) return

    Array.prototype.slice.call(this.dom.buttons).forEach(button => { button.classList.remove("is-selected") })
    el.classList.add("is-selected")

    gsap.to([this.dom.top, this.dom.bottom, this.dom.adjustmentLayer], 0.2, { opacity: 0, ease: "sine.in" })
    gsap.to(layers, 0.2, { opacity: 1, ease: "sine.in" })

    this.dom.bottom = Array.from(layers).filter(layer => layer.classList.contains("bottom"));
    this.dom.top = Array.from(layers).filter(layer => layer.classList.contains("top"));
    this.dom.adjustmentLayer = Array.from(layers).filter(layer => layer.classList.contains("adjustment-layer"));

    this.setPatternSize(scaleFactor)
  }

  hotSwapPattern(imgUrl) {
    let currentPattern = this.dom.el.querySelector(".image-pattern.active")
    currentPattern.style.backgroundImage = "url('" + imgUrl + "')";
  }

  setPatternSize(scaleFactor) {
    let vwScale = window.innerWidth / 1280;

    Array.prototype.slice.call(this.dom.patterns).forEach(pattern => {

      let patternWidth = pattern.dataset ? pattern.dataset.patternWidth : 400;
      let patternHeight = pattern.dataset ? pattern.dataset.patternHeight : 600;

      let width = patternWidth * scaleFactor * vwScale;
      let height = patternHeight * scaleFactor * vwScale;

      gsap.set(pattern, { backgroundSize: `${width}px ${height}px` })
    })

    this.data.scaleFactor = scaleFactor;
  }

  setCurrentPattern(productId, color) {

    Array.prototype.slice.call(this.dom.patterns).forEach(pattern => { pattern.classList.remove("active") })

    let el = this.dom.el.querySelector(`.color-${color}`);

    if (el) {
      el.classList.add("active");
    }
  }

  /*--------  SLIDER --------*/

  circleDown() {
    this.data.isMouseDown = true;
    this.dom.roomContainer.classList.add("is-mouse-down");
    gsap.to(this.dom.slideElCircle, 0.25, { scale: 1.3, ease: "sine.out" })
    gsap.to(this.dom.slideElCircleOuter, 0.25, { scale: .7, opacity: 0, ease: "sine.out" })
  }

  circleUp(e) {

    if (!e || !this.data.isMouseDown) return

    this.data.isMouseDown = false;
    this.dom.roomContainer.classList.remove("is-mouse-down");

    let x = e.clientX || e.touches[0].pageX;

    x = clamp(x, this.data.bounds.left, this.data.bounds.width + this.data.bounds.left)

    let pct = ((x - this.data.bounds.left) / this.data.bounds.width) * 100;
    let newX = x - this.data.halfWidth - this.data.bounds.left;

    gsap.to(this.dom.slideEl, .9, { x: newX, rotate: 0, ease: "expo.out" });

    gsap.to(this.dom.slideElCircle, 0.25, { scale: 1, ease: "sine.out" })
    gsap.to(this.dom.slideElCircleOuter, 0.25, { scale: 1., opacity: 1, ease: "sine.out" })

    this.clip.top = pct;
    this.clip.bottom = pct;
    gsap.to(this.dom.middle, .9, { webkitClipPath: `polygon(0 0, ${this.clip.top}% 0, ${this.clip.bottom}% 100%, 0% 100%)`, clipPath: `polygon(0 0, ${this.clip.top}% 0, ${this.clip.bottom}% 100%, 0% 100%)`, ease: "expo.out", });
  }

  getBounds() {

    if (!this.dom || !this.dom.roomContainer) return;

    let bounds = this.dom.roomContainer.getBoundingClientRect();

    this.data.bounds = bounds;
    this.data.halfWidth = bounds.width / 2;
    this.data.halfHeight = bounds.height / 2;
  }

  move(e) {
    if (!e || !this.data.isMouseDown) return

    e.preventDefault();

    let x = e.clientX || e.touches[0].pageX;
    // x += this.data.bounds.left;
    x = clamp(x, this.data.bounds.left, this.data.bounds.width + this.data.bounds.left)

    let newX = x - this.data.halfWidth - this.data.bounds.left;

    // Drag Progress from 0 - 100 
    let pct = ((x - this.data.bounds.left) / this.data.bounds.width) * 100;

    // console.log(x, pct)

    // Move Circle and Line 
    let newRotate = 0;
    if (this.speed) {
      newRotate = this.speedX * this.clip.mulitiplier;
      newRotate = clamp(newRotate, -5, 5)
    }

    gsap.to(this.dom.slideEl, this.data.ease, { x: newX, rotate: newRotate, ease: "none" });

    // Calc new clip mask position
    this.clip.top = pct + (pct / 100) * newRotate;
    this.clip.bottom = pct - (pct / 100) * newRotate;
    gsap.to(this.dom.middle, this.data.ease, { webkitClipPath: `polygon(0 0, ${this.clip.top}% 0, ${this.clip.bottom}% 100%, 0% 100%)`, clipPath: `polygon(0 0, ${this.clip.top}% 0, ${this.clip.bottom}% 100%, 0% 100%)`, ease: "none", });

  }

  setSpeed() {
    this.speedX = this.speed.speedX;
    this.speedY = this.speed.speedY;
  }

  mouseLeave(e) {
    this.circleUp(e);
  }

  resize() {
    this.getBounds();
    this.setPatternSize(this.data.scaleFactor)
  }

  destroy() {
    if (this.speed) this.speed.destroy();
  }
}